export default "__VITE_ASSET__gO_KGNfL__"